import Entity from './entity'
import locationItems from './locationItems'

export default class Location extends Entity<number>{    
    locationCode:string;
    locationType:string;
    locationTypeName:string;
    objectType : string;
    objectTypeName : string;
    status : string;
    lastModificationTime : Date;
    lastModifierUserId : number;
    lastModifierUserName : string;
    items : Array<locationItems>;
    statusName:string;
    storageTypeName:string;
}